import React, { useMemo, useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { LoanData } from '../types/loan';
import { LoanTableHeader } from './LoanTableHeader';
import { LoanTableRow } from './LoanTableRow';
interface StageCardProps {
  stage: string;
  loans: LoanData[];
  accentColor: string;
  onUpdateLoan: (loan: LoanData) => void;
}
function parseCurrency(value: string): number {
  if (!value || value === '—' || value === 'Empty') return 0;
  return Number(value.replace(/[^0-9.-]/g, '')) || 0;
}
function formatCurrency(value: number): string {
  return '$' + value.toLocaleString('en-US');
}
export function StageCard({
  stage,
  loans,
  accentColor,
  onUpdateLoan
}: StageCardProps) {
  const [isOpen, setIsOpen] = useState(true);
  const volumeTotal = useMemo(() => {
    return loans.reduce((sum, loan) => sum + parseCurrency(loan.loanAmount), 0);
  }, [loans]);
  if (!loans || loans.length === 0) return null;
  return <div className="rounded-2xl overflow-hidden bg-white shadow-[0_1px_3px_rgba(0,0,0,0.04),0_4px_12px_rgba(0,0,0,0.03)] border border-slate-200/60" data-id="element-69">
      {/* Stage header */}
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 flex items-center gap-4 focus:outline-none transition-all duration-150 hover:brightness-[1.05]" style={{
      backgroundColor: accentColor
    }} data-id="element-70">
        {/* Chevron */}
        <div className="w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0 bg-white/15" data-id="element-71">
          {isOpen ? <ChevronDown className="w-4 h-4 text-white" data-id="element-72" /> : <ChevronRight className="w-4 h-4 text-white" data-id="element-73" />}
        </div>

        {/* Stage name */}
        <span className="font-bold text-[16px] tracking-wide uppercase flex-shrink-0 text-white" data-id="element-74">
          {stage}
        </span>

        {/* Count pill */}
        <span className="text-[12px] font-bold px-3 py-1 rounded-full flex-shrink-0 bg-white/20 text-white" data-id="element-75">
          {loans.length} {loans.length === 1 ? 'loan' : 'loans'}
        </span>

        <div className="flex-1" data-id="element-76" />

        {/* Volume */}
        <div className="flex items-center gap-2 flex-shrink-0" data-id="element-77">
          <span className="text-[12px] text-white/60 font-medium uppercase tracking-wider" data-id="element-78">
            Volume
          </span>
          <span className="text-[16px] text-white font-bold tabular-nums" data-id="element-79">
            {formatCurrency(volumeTotal)}
          </span>
        </div>
      </button>

      {/* Table content */}
      {isOpen && <div className="border-t border-slate-100" data-id="element-80">
          <div className="overflow-x-auto" data-id="element-81">
            <table className="w-full text-left border-collapse" data-id="element-82">
              <LoanTableHeader data-id="element-83" />
              <tbody data-id="element-84">
                {loans.map(loan => <LoanTableRow key={loan.id} data={loan} onUpdate={(field, value) => {
              onUpdateLoan({
                ...loan,
                [field]: value
              });
            }} data-id="element-85" />)}
              </tbody>
            </table>
          </div>
        </div>}
    </div>;
}